import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ICombinedState from "../../../redux/model/ICombinedState";
import {
  LOGIN,
  VISA_AUTH_REDIRECT,
  VISA_AUTH,
} from "../../../constants/ROUTER_PATH_TITLE";
import Model from "@tripian/model";

const PrivateRoute: React.FC<{ element: React.ReactNode }> = ({ element }) => {
  const { isLoggedIn, user } = useSelector((state: ICombinedState) => ({
    isLoggedIn: state.user.isLoggedIn,
    user: state.user.user,
  }));

  const isVisaFlow = window.tconfig?.ELIGIBILITY_TYPE === "visa";
  const needsVisaRedirect =
    isVisaFlow && user && user.userType !== Model.USER_TYPE.ELIGIBILITY;

  // If not logged in, redirect to login page
  if (!isLoggedIn) {
    return <Navigate to={LOGIN.PATH} replace />;
  }

  if (!user) return null;

  // If user is logged in but needs a visa redirect
  // Don't redirect if we're already on VISA_AUTH_REDIRECT or VISA_AUTH pages
  if (
    needsVisaRedirect &&
    window.location.pathname !== VISA_AUTH_REDIRECT.PATH &&
    window.location.pathname !== VISA_AUTH.PATH
  ) {
    return (
      <Navigate
        to={VISA_AUTH_REDIRECT.PATH}
        replace
        state={{ visaSource: "guard" }}
      />
    );
  }

  // If everything is okay, return the element
  return <>{element}</>;
};

export default PrivateRoute;
